import React from 'react';

import i18n from '@components/i18n/i18n';
import { FieldWrap, FieldMessages, FieldLabel, FieldError } from '../common';
import { FieldTextarea } from './Textarea.styles';

const Textarea = ({
  id,
  name,
  label,
  register,
  errors,
  dark = false,
  ...rest
}) => {
  const language = i18n.language;
  const dir = i18n.dir();

  return (
    <FieldWrap>
      <FieldMessages>
        <FieldLabel htmlFor={id} dark={!!dark}>
          {label}
        </FieldLabel>
        {errors && errors[name] && (
          <FieldError>{errors[name].message}</FieldError>
        )}
      </FieldMessages>
      <FieldTextarea
        id={id}
        name={name}
        ref={register}
        error={errors && errors[name] ? true : false}
        dark={!!dark}
        {...rest}
      />
    </FieldWrap>
  );
};

export default Textarea;
